export function get_asset_preview_element_id(asset_index: number) {
  return `portfolio-asset-${asset_index + 1}`;
}
